import React, { useEffect } from 'react';
import {
  Box,
  Stack,
} from '@mantine/core';
import { useParams, Navigate } from 'react-router-dom';

import { useAuth } from '../Auth';
import HomePageHero from '../components/HomePageHero';
import HomePageTimeline from '../components/HomePageTimeline';
import HomePageDemo from '../components/HomePageDemo';
import HomePageTestimonials from '../components/HomePageTestimonials';
import HomePagePricing from '../components/HomePagePricing';
import HomePageFooter from '../components/HomePageFooter';
import { InlineBackground, FooterBackground } from '../components/HomePageBackground';

function LoginRoute() {
  const { isAuthenticated, login } = useAuth();
  const { token } = useParams();
  const spotifyAuthUrl = `${process.env.REACT_APP_API_HOST}/auth/spotify`;

  useEffect(() => {
    if (token) {
      login(token);
    }
  }, [login, token]);

  return (
    <>
      {isAuthenticated && <Navigate to='/games' replace />}
      <Stack spacing={0}>

        <HomePageHero spotifyAuthUrl={spotifyAuthUrl} />

        <HomePageTimeline />

        <InlineBackground />

        <HomePageDemo />

        <HomePageTestimonials />

        <Box> 
          <FooterBackground>
            <HomePagePricing spotifyAuthUrl={spotifyAuthUrl} />
            <HomePageFooter />
          </FooterBackground>
        </Box>

      </Stack>
    </>
  );
}

export default LoginRoute;


